import React from 'react';
import { Box, Paper, Tooltip } from '@mui/material';
import { CheckCircle, List, Star } from '@mui/icons-material';
import { codeColorMap, codeColorMapHover } from 'lib/colors';




const SymbolRow = ({
	code: {
		symbol_name,
		symbol_category,
		symbol_abbreviation,
		clinic_id,
		symbol_chart_config,
	},
	isActive = false,
	onClick,
}) => {
	const color = codeColorMap[ symbol_category ] ?? codeColorMap.other;
	const hoverColor = codeColorMapHover[ symbol_category ] ?? codeColorMapHover.other;

	return (
		<Box display="flex">
			<Box
				sx={{
					maxHeight: '100px',
					overflowY: 'auto',
					marginBottom: 1,
					marginLeft: 2,
					marginRight: isActive
						? 1
						: 2,
					width: isActive
						? 'calc(100% - 70px)'
						: '100%',
				}}
				onClick={onClick}
			>
				<Paper
					sx={{
						borderLeft: `15px solid ${color}`,
						padding: 1.5,
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						background: `linear-gradient(to left, ${isActive
							? '#ededed'
							: '#ffffff'} 50%, #ededed 50%)`,
						backgroundSize: '201% 100%',
						backgroundPosition: 'right bottom',
						transition: 'all 400ms ease',
						'&:hover': {
							borderLeft: `15px solid ${hoverColor}`,
							backgroundPosition: 'left bottom',
						},
					}}
					variant="outlined"
				>
					{Boolean(clinic_id) &&
						<Tooltip title="This is a custom, non-AVDC code" placement="top">
							<Star
								sx={{
									color,
									marginRight: 1,
								}}
							/>
						</Tooltip>
					}

					{`${symbol_name} (${symbol_abbreviation})`}

					{symbol_chart_config?.type === 'multiselect' &&
						<div style={{ marginLeft: 'auto' }}>
							<Tooltip title="Multiple-choice code" placement="top">
								<List
									sx={{
										color,
										marginLeft: 2,
									}}
								/>
							</Tooltip>
						</div>
					}
				</Paper>
			</Box>
			{isActive && (
				<Box sx={{ height: '50px' }}>
					<Tooltip title="This is your currently-selected code">
						<CheckCircle style={{ color: 'green', marginTop: '10px', fontSize: '30px' }} />
					</Tooltip>
				</Box>
			)}
		</Box>
	);
};

export default SymbolRow;
